import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background-color: ${theme.colors.tertiary.lime[10]};
    border-radius: 8px;
    margin-bottom: 16px;
  `,
  iconContainer: css`
    display: flex;
    height: 100%;
  `,
  icon: ({ theme }) => css`
    background-color: ${theme.colors.tertiary.lime[20]};
    height: 22px;
    width: 22px;
    display: flex;
    text-align: center;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
  `,
  message: css`
    flex: 1;
    color: #92400e;
  `,
  closeContainer: css`
    display: flex;
    height: 100%;
    align-items: flex-start;
  `,
  closeIcon: ({ theme }) => css`
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.tertiary.lime[60]};
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
